/* globals angular */
(function () {
    'use strict';

angular.module('AngularAdmin')


// Directive: 	load-to-scope
// Description: Load a JSON String to the scope. 
//				NOTE: should only be used as a temporary solution.
.directive('loadToScope', function () { 
    function link(scope, element, attrs) {
        var text = element.text();
        var variable = attrs['loadToScope'];
        scope.$eval(variable + ' = ' + text);

        if(attrs['then']) {
            scope.$eval(attrs['then']);
        }
    }
    return { link: link }
});

})();